import React, { useState } from 'react';
import { Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

//Components
import TabelaListagem from '../TabelaListagem/TabelaListagem';
import ModalCustomized from '../Modal/Modal';

//Helpers
import { downloadZip } from '../../helpers/downloadFile';
import { CATEGORIA_REGRA, CATEGORIA_VERSAO, descricaoCategoria, filtrarPorCategoria } from '../../views/AreaRestrita/Cadastros/RegrasEVersoes/helpers/regrasEVersoes';

//Constants
import { actionsTable } from '../../constants/MaterialTable';

// Listagem somente leitura de Regras e Versões do Sistema, em duas abas (CE-3522).
// Não faz chamada à API: recebe os itens já carregados e uma função que busca o detalhe,
// para servir tanto à tela autenticada quanto à consulta pública.
export default function ConsultaRegrasVersoes({ itens = [], carregarDetalhe }) {

    //Aba ativa: Regras do Sistema ou Versão do Sistema
    const [categoriaAtiva, setCategoriaAtiva] = useState(CATEGORIA_REGRA);

    //Item aberto no modal de visualização
    const [itemVisualizado, setItemVisualizado] = useState(null);

    const headers = [
        { value: "Data da Publicação", objectValue: "dataPublicacaoFormatada", align: "left" },
        { value: "Título", objectValue: "titulo", align: "left" }
    ];

    const visualizar = (rowData) => {
        carregarDetalhe(rowData).then(detalhe => setItemVisualizado(detalhe));
    };

    const actions = [actionsTable.visualizar(visualizar)];

    const abaClassName = (categoria) =>
        `${categoriaAtiva === categoria ? "active fw-bold text-success" : "text-secondary"}`;

    const abaStyle = (categoria) =>
        ({ backgroundColor: categoriaAtiva === categoria ? "#fff" : "#ccc" });

    return (
        <>
            {itemVisualizado &&
                <ModalCustomized
                    toggle={() => setItemVisualizado(null)}
                    isOpen={!!itemVisualizado}
                    btnClose={true}
                    size="md"
                    fullscreen="sm"
                    widthPadrao={false}
                    title={itemVisualizado.titulo}
                    btnAction={itemVisualizado.linkArquivo
                        ? <><FontAwesomeIcon icon={faFilePdf} /> Baixar arquivo</>
                        : null}
                    btnActionColor="danger"
                    onClickBtnAction={() => downloadZip(itemVisualizado.arquivo, itemVisualizado.linkArquivo)}
                >
                    <Row className='g-3'>
                        <Col xs="6">
                            <small className='text-secondary d-block'>Categoria</small>
                            {descricaoCategoria(itemVisualizado.categoria)}
                        </Col>
                        <Col xs="6">
                            <small className='text-secondary d-block'>Data da Publicação</small>
                            {moment(itemVisualizado.dataPublicacao).format("DD/MM/YYYY")}
                        </Col>
                        <Col xs="12">
                            <small className='text-secondary d-block'>Descrição</small>
                            <p className='mb-0' style={{ whiteSpace: "pre-wrap" }}>{itemVisualizado.descricao}</p>
                        </Col>
                    </Row>
                </ModalCustomized>
            }
            <Nav tabs className='mb-3'>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={abaStyle(CATEGORIA_REGRA)}
                        className={abaClassName(CATEGORIA_REGRA)}
                        onClick={() => setCategoriaAtiva(CATEGORIA_REGRA)}
                    >
                        Regras do Sistema
                    </NavLink>
                </NavItem>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={abaStyle(CATEGORIA_VERSAO)}
                        className={abaClassName(CATEGORIA_VERSAO)}
                        onClick={() => setCategoriaAtiva(CATEGORIA_VERSAO)}
                    >
                        Versões do Sistema
                    </NavLink>
                </NavItem>
            </Nav>
            <TabelaListagem
                actions={actions}
                title={categoriaAtiva === CATEGORIA_REGRA ? "Regras do Sistema" : "Versões do Sistema"}
                options={{ print: false, search: true, pagination: true }}
                headers={headers}
                items={filtrarPorCategoria(itens, categoriaAtiva)}
            />
        </>
    )
}
